module.exports = __webpack_public_path__ + "static/media/stofferingen-05.16defb25.jpg";